import { render, staticRenderFns } from "./home-mcp-details-modal.component.vue?vue&type=template&id=336e603d&scoped=true&"
import script from "./home-mcp-details-modal.component.vue?vue&type=script&lang=ts&"
export * from "./home-mcp-details-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-mcp-details-modal.component.vue?vue&type=style&index=0&id=336e603d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336e603d",
  null
  
)

export default component.exports